import { defineMessages } from 'react-intl';

export const BASE_CODE_EDITOR_MESSAGES = defineMessages({
  diagnosticsSummarySingle: {
    defaultMessage: '1 {severity} on line {line}: {message}',
    id: 'EAU3RUdvyoar4XEO',
    description:
      'Screen reader announcement when there is exactly one diagnostic. {severity} is the translated severity label, {line} is the 1-based line number.',
  },
  diagnosticsSummaryMultiple: {
    defaultMessage: '{count} diagnostics: {list}',
    id: 'p7QNWYWAN7FysSqc',
    description:
      'Screen reader announcement when there are multiple diagnostics. {list} is a period-separated list of severity/line/message items.',
  },
  diagnosticsSummaryListItem: {
    defaultMessage: '{severity} on line {line}: {message}',
    id: 'ws6glsra1rg4EAIA',
    description:
      'One entry in the multiple-diagnostics list. {severity} is the translated severity label, {line} is the 1-based line number.',
  },
  diagnosticsSeverityError: {
    defaultMessage: 'error',
    id: 'RwWfbCK3X+5Ie3vr',
    description:
      'Severity label for an error diagnostic, used in screen reader announcements.',
  },
  diagnosticsSeverityWarning: {
    defaultMessage: 'warning',
    id: 'uLZU9AJNAIdoZ08c',
    description:
      'Severity label for a warning diagnostic, used in screen reader announcements.',
  },
  diagnosticsSeverityInfo: {
    defaultMessage: 'info',
    id: 'IwwqXNaWxNjk1Su9',
    description:
      'Severity label for an info diagnostic, used in screen reader announcements.',
  },
  offScreenErrorCount: {
    defaultMessage: '{count, plural, one {# error} other {# errors}}',
    id: 'OBIv2/oXhdnWDW/Z',
    description:
      'Visible label on a pill button indicating how many error-severity diagnostics are scrolled out of view. {count} is the number of errors.',
  },
  offScreenErrorCountCapped: {
    defaultMessage: '99+ errors',
    id: 'IAzId4iIfCf1TztP',
    description:
      'Visible label on a pill button when more than 99 error-severity diagnostics are scrolled out of view.',
  },
  offScreenErrorsAboveLabel: {
    defaultMessage:
      '{count, plural, one {# error} other {# errors}} above the visible area. Activate to scroll to the nearest one.',
    id: 'NHGVmhAtHDO9Lh7I',
    description:
      'Accessible label for the top pill button. {count} is the number of error-severity diagnostics above the visible area.',
  },
  offScreenErrorsBelowLabel: {
    defaultMessage:
      '{count, plural, one {# error} other {# errors}} below the visible area. Activate to scroll to the nearest one.',
    id: '4MPw/PUwxwPT3S/6',
    description:
      'Accessible label for the bottom pill button. {count} is the number of error-severity diagnostics below the visible area.',
  },
});
